import React from 'react'
import { ArrowRight, VyberHeader, Logo, LinkMore } from './StyledVyberHeader'
import Link from '../../utils/Link'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'

const Header = ({ target, utmParams }) => {
  const linkWithUtm = utmLinkGenerator.createLink('https://vyber.centrum.cz/', { ...utmParams, utmTerm: 'headline' })
  const moreLinkWithUtm = utmLinkGenerator.createLink('https://vyber.centrum.cz/', { ...utmParams, utmTerm: 'morelink' })

  return (
    <VyberHeader>
      <Link href={linkWithUtm} target={target} >
        <Logo src={`${STATICS_PATH}images/vyber/centrum-vyber.svg`} />
      </Link>
      <LinkMore href={moreLinkWithUtm} target={target} >Přejít na výběr <ArrowRight /></LinkMore>
    </VyberHeader>
  )
}

export default Header
